/**
 * When the API serves the rider build at `/rider/`, react-router needs the
 * basename to match. In standalone dev (vite at `/`), no basename is needed.
 */
export const ROUTER_BASENAME: string = (() => {
  if (typeof window === 'undefined') return '';
  const path = window.location.pathname;
  if (path === '/rider' || path.startsWith('/rider/')) return '/rider';
  return '';
})();
